// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"cc243452","646":"1274e953","845":"29271532"}[chunkId] + ".chunk.js";
};